export default {
    namespaced: true,
    state: {
        dadosTransferencia: null,
        dadosMarcacoes: null,
    },
    getters: {
        getDadosTransferencia(state) {
            return state.dadosTransferencia;
        },    
        getDadosMarcacoes(state) {
            return state.dadosMarcacoes;
        }          
    },
    mutations: {        
        setDadosTransferencia(state, dados) {
            state.dadosTransferencia = dados;
        }, 
        setDadosMarcacoes(state, dados) {
            state.dadosMarcacoes = dados;
        }  
    },
    actions: {        
        inluirDadosTransferencia(context, dados) {            
            context.commit('setDadosTransferencia', dados);  
        },
        inluirDadosMarcacoes(context, dados) {
            context.commit('setDadosMarcacoes', dados);  
        },
        limparDadosTransferencia(context) {            
            context.commit('setDadosTransferencia', null);  
        },
        limparDadosFuncionario(context) {
            context.commit('setDadosTransferencia', null); 
            context.commit('setDadosMarcacoes', null);  
        }     
    }
}